import { useState } from 'react';

import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab3 = ({ pageState, handleChange, Company, WorkOrder, workOrderList, companyList }) => {
  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">More Information</p>
      </div>

      <div className="col-6 ">
        <div className={`mb-3`}>
          <Input
            id="SerialNo"
            readOnly
            label="Company"
            style={{
              height: "30px",

            }}
            value={pageState?.company || ""}
            onChange={(e) => handleChange('serialNo', e.target.value)}

          />
        </div>
      </div>

      <div className="col-6">
        <div className={`mb-3`}>
          <SelectSearch
            list={workOrderList || []}
            style={{
              height: "38px",

            }}
            label="Work Order"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={pageState.workOrder || null}
            onChange={(val) => handleChange('workOrder', val)}
          />
        </div>
      </div>
    </div>
  );
};

export default Tab3;